import {
  PageTableType,
} from "../../redux/Types";
import {
  ColumnStickyTypes,
  ColumnTypes,
  JustificationTypes,
} from "../../util/table-view/TableTypes"
//"../../util/table-view/TableTypes";
import React from "react";
import moment from "moment";
import store from "../../redux/Store";
import Player from "modules/ml-player/Player";
import DurationDisplay from "../../util/DurationDisplay";

const col = {

  selector: {
    width: 18,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.selector,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_TRACKS,
  },
  trackTitle: {
    width: 200,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.elasticString,
  },
  player: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.playerAndThumb,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_TRACKS,
    artworkField: () => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      return trackFields.prodArtworkUrl.id;
    },
    cellProp: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      return {
        artworkProps: {
          alt: `Art work for ${rowData[trackFields.trackTitle.id]}`,
        },
        playerProps: {
          ariaLabel: `Play track ${rowData.trackTitle}`,
        },
      };
    },
  },
  downloader: {
    width: 40,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.downloader,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_TRACKS,
  },
  id: {
    width: 220,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.identity,
  },
  prodName: {
    width: 160,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.elasticString,
  },
  performer: {
    width: 160,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.elasticString,
  },
  position: {
    width: 110,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.elasticString,
  },
  duration: {
    width: 40,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.number,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    cellRenderer: (rowData) => (
      <DurationDisplay seconds={rowData?.duration} />
    ),
  },
  genres: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.tag,
  },
  moods: {
    width: 90,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.tag,
  },
  styles: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.tag,
  },
  keywords: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isFilterable: false,
    isSortable: false,
    discretable: false,
    type: ColumnTypes.tag,
  },
};
export default col;
